import { ApolloLink, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';

export const splitLink = (wsLink: ApolloLink, restLink: ApolloLink) =>
  split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    // if above is true, WS
    wsLink,
    // REST otherwise
    restLink
  );
